import React, {useContext, useMemo} from 'react';


import {mapDateFormat} from 'src/utils/mapDateFormat';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    timestamp?: string | null,
};

export const SavedTableTimestampCell = ({timestamp}: Props) => {
    const {locale} = useContext(LocaleContext);

    const value = useMemo(
        () => {
            if (!timestamp) {
                return '';
            }

            return FormattedDate.format({
                value: timestamp,
                format: mapDateFormat(locale.dateFormat, 'WORD', 'DATE'),
            }) || '';
        },
        [timestamp, locale.dateFormat],
    );

    if (!timestamp) {
        return null;
    }

    return (
        <EllipsisTextHint title={value}>{value}</EllipsisTextHint>
    );
};
